import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { TicketAssignStatus } from '@sb-tools/typescript/enums/ticket-assign-status.enum';

@Injectable({ providedIn: 'root' })
@Pipe({ name: 'assignStatus' })
export class AssignStatusPipe implements PipeTransform {
    constructor(private translateService: TranslateService) {}

    transform(assignStatus: TicketAssignStatus): string {
        switch (assignStatus) {
            case TicketAssignStatus.assigned:
                return this.translateService.instant('Assigned');
            case TicketAssignStatus.unassigned:
                return this.translateService.instant('Unassigned');
            case TicketAssignStatus.all:
                return this.translateService.instant('All');
            default:
                return this.translateService.instant('Unknown status');
        }
    }
}
